import { selectMultiple } from "../../consts/description";
import { isRequired } from "../../consts/required";
import { no, yes } from "../../consts/yes_no";

const s5q1 = {
  type: "matrixdropdown",
  name: "q4s5q1",
  isRequired: isRequired,
  title: {
    default:
      "In the past 12 months, has your child ever had an illness or trouble caused by eating a food or foods or even a diagnosis of food allergy in the following food groups?",
    gr: "Τους τελευταίους 12 μήνες, είχε ποτέ το παιδί σας κάποια ασθένεια ή πρόβλημα που προκλήθηκε από την κατανάλωση κάποιας τροφής ή διάγνωση τροφικής αλλεργίας από τις παρακάτω ομάδες τροφών;",
    fr: "Au cours des 12 derniers mois, votre enfant a-t-il déjà été malade ou a eu un souci lié à la consommation d’un ou plusieurs aliments ou même un diagnostic d’allergie alimentaire dans les groupes d’aliments suivants ?",
    de: "",
    ka: "ბოლო 12 თვის განმავლობაში,, თქვენს შვილს  როდესმე თუ ჰქონია დაავადება ან სიმპტომი რომელიც გამოწვეული იყო საკვების მიღებით ან თუ აღენიშნება დიაგნოსტირებული კვებითი ალერგია ქვემოთ მოყვანილ  საკვების ჯგუფებზე?",
    fi: "Viimeisten 12 kuukauden aikana, onko lapsellasi koskaan ollut ruoan tai elintarvikkeiden syömisen aiheuttamaa sairautta, ongelmia tai ruoka-allergian diagnoosia seuraavissa ruokaryhmissä?",
  },
  horizontalScroll: true,
  columnMinWidth: "130px",
  columns: [
    {
      name: "yes_or_no",
      title: {
        default: "Yes/No",
        gr: "Ναι/Όχι",
        fr: "Oui/Non",
        de: "",
        ka: "კი/არა",
        fi: "Kyllä/Ei",
      },
      choices: [yes, no],
      cellType: "radiogroup",
      colCount: 2, 
      isRequired: isRequired,
    },
  ],
  rows: [
    {
      value: "milk",
      text: {
        default: "Milk",
        gr: "Γάλα",
        fr: "Lait",
        de: "",
        ka: "რძე",
        fi: "Maito",
      },
    },
    {
      value: "egg",
      text: {
        default: "Egg",
        gr: "Αυγό",
        fr: "Œuf",
        de: "",
        ka: "კვერცხი",
        fi: "Muna",
      },
    },
    {
      value: "wheat",
      text: {
        default: "Wheat",
        gr: "Σιτηρά",
        fr: "Blé",
        de: "",
        ka: "ხორბალი",
        fi: "Vehnä",
      },
    },
    {
      value: "soy",
      text: {
        default: "Soy",
        gr: "Σόγια",
        fr: "Soja",
        de: "",
        ka: "სოიო",
        fi: "Soija",
      },
    },
    {
      value: "fish",
      text: {
        default: "Fish",
        gr: "Ψάρι",
        fr: "Poissons",
        de: "",
        ka: "თევზი",
        fi: "Kala",
      },
    },
    {
      value: "tree_nuts",
      text: {
        default: "Tree nuts",
        gr: "Ξηροί καρποί",
        fr: "Fruits à coque",
        de: "",
        ka: "თხილეული",
        fi: "Pähkinät",
      },
    },
  ],
};

const s5q2 = {
  type: "checkbox",
  name: "q4s5q2",
  title: {
    default: "Did this illness or trouble include:",
    gr: "Αυτή η ασθένεια ή το πρόβλημα περιλάμβανε:",
    fr: "Ces symptômes ou soucis incluaient-ils:",
    de: "",
    ka: "მოიცავდა თუ არა საკვების მიღებასთან  დაკავშირებული პრობლემები  ქვემოთ მოყვანილ რომელიმე სიმპტომს ?",
    fi: "Esiintyikö tämän sairauden tai ongelman yhteydessä:",
  },
  description: selectMultiple,
  choices: [
    {
      text: {
        default:
          "Itching/Pruritus (hard continuous scratching leading to excoriations)",
        gr: "Φαγούρα/ Κνησμό (Έντονο συνεχόμενο ξύσιμο που οδηγεί σε πληγές)",
        fr: "Prurit (grattage dur et continu entraînant des excoriations)",
        de: "",
        ka: "ქავილი ( ძლიერი მუდმივი ქავილი ექსკორიაციების-ნაკაწრების წარმოქმნით)",
        fi: "Kutina (kova jatkuva raapiminen, joka johtaa hankaumiin)",
      },
      value: "pruritus",
    },
    {
      text: {
        default: "Urticaria (more than 2 hives)",
        gr: "Κνίδωση-Εξάνθημα (πάνω από δύο βλάβες)",
        fr: "Urticaire (plus de 2 papules)",
        de: "",
        ka: "ურტიკარია (ჭინჭრის ციების 2-ზე მეტი ელემენტით)",
        fi: "Urtikaria (yli 2 nokkosihottumaa)",
      },
      value: "urticaria",
    },
    {
      text: {
        default: "Swelling on lip and/or face",
        gr: "Οίδημα-Πρήξιμο χειλέων ή/και προσώπου ",
        fr: "Gonflement des lèvres et/ou du visage",
        de: "",
        ka: "ტუჩების და/ან სახის შეშუპება",
        fi: "Huulten ja/tai kasvojen turvotus",
      },
      value: "swelling",
    },
    {
      text: {
        default: "Worsening of eczema",
        gr: "Επιδείνωση εκζέματος",
        fr: "Aggravation de l’eczéma",
        de: "",
        ka: "ეგზემის გამწვავება",
        fi: "Ihottuman paheneminen",
      },
      value: "worsening_eczema",
    },
    {
      text: {
        default: "Frequent sniffing and/or bursts of sneezing",
        gr: "Συχνό ρουθούνισμα ή/και εξάρσεις φτερνίσματος",
        fr: "Reniflements et/ou éternuements fréquents",
        de: "",
        ka: "ინტენსიური ყნოსვა/ცემინება ",
        fi: "Usein toistuva niistäminen ja/tai aivastelu.",
      },
      value: "sniffing",
    },
    {
      text: {
        default: "Cough/Wheezing",
        gr: "Βήχα/Σφύριγμα-Βράσιμο στο στήθος",
        fr: "Toux/respiration sifflante",
        de: "",
        ka: "ხველა/ხიხინი",
        fi: "Yskä/hengityksen vinkuminen",
      },
      value: "cough_wheezing",
    },
    {
      text: {
        default: "Vomiting (Emesis)",
        gr: "Εμετός",
        fr: "Vomissements",
        de: "",
        ka: "ღებინება",
        fi: "Oksentaminen",
      },
      value: "emesis",
    },
    {
      text: {
        default: "Diarrhea",
        gr: "Διάρροια",
        fr: "Diarrhée",
        de: "",
        ka: "დიარეა",
        fi: "Ripuli",
      },
      value: "diarrhea",
    },
    {
      text: {
        default:
          "Change in mental status (unexplained drowsiness or agitation)",
        gr: "Αλλαγή στη διανοητική κατάσταση (ανεξήγητη υπνηλία ή διέγερση)",
        fr: "Modification de l’état de conscience (somnolence ou agitation inexpliquée)",
        de: "",
        ka: "მენტალური სტატუსის ცვლილება  (აუხსნელი  მოთენთვა ან გაღიზიანება)",
        fi: "Psyykkisen tilan muutos (selittämätön uneliaisuus tai levottomuus)",
      },
      value: "change_mental_status",
    },
    {
      text: {
        default: "Loss of consciousness",
        gr: "Απώλεια συνείδησης",
        fr: "Perte de conscience",
        de: "",
        ka: "გონების დაკარგვა",
        fi: "Tajunnan menetys",
      },
      value: "loss_consciousness",
    },
  ],
  isRequired: isRequired,
  colCount: 1,
  showOtherItem: true,
  separateSpecialChoices: true,
};

const s5q3 = {
  type: "radiogroup",
  name: "q4s5q3",
  colCount: 3,
  title: {
    default: "How soon after eating did the symptoms occur?",
    gr: "Πόσο σύντομα αφού έφαγε την τροφή εμφανίστηκαν τα συμπτώματα;",
    fr: "Combien de temps après avoir mangé les symptômes sont-ils apparus ?",
    de: "",
    ka: "რამდენად სწრაფად განვითარდა სიმპტომები საკვების მიღების შემდეგ?",
    fi: "Kuinka pian syömisen jälkeen oireet ilmenivät?",
  },
  isRequired: isRequired,
  choices: [
    {
      text: {
        default: "Only within 2 hours",
        gr: "Μόνο εντός 2 ωρών",
        fr: "Dans les 2 heures exclusivement",
        de: "",
        ka: "2 საათში",
        fi: "Vain 2 tunnin kuluessa",
      },
      value: "within_2h",
    },
    {
      text: {
        default: "Only after 2 hours",
        gr: "Μόνο μετά από 2 ώρες",
        fr: "Après 2 heures exclusivement",
        de: "",
        ka: "2 საათის შემდეგ",
        fi: "Vasta 2 tunnin kuluttua",
      },
      value: "after_2h",
    },
    {
      text: {
        default: "both",
        gr: "Και τα δύο",
        fr: "Les deux",
        de: "",
        ka: "ორივე ფორმით",
        fi: "Molemmat",
      },
      value: "both",
    },
  ],
};
// const s5q4 = {
//   name: "q4s5q4",
//   title: {
//     default: "How old was your child (in years) when these symptoms occurred?",
//     gr: "",
//     fr: "",
//     de: "",
//     ka: "",
//     fi: "",
//   },
//   inputType: "number",
//   isRequired: isRequired,
// };

const s5q4 = {
  type: "radiogroup",
  name: "q4s5q4",
  title: {
    default:
      "Has your child been diagnosed by a doctor as having an allergy to this food?",
    gr: "Έχει ποτέ διαγνωστεί από γιατρό ότι το παιδί σας έχει αλλεργία σε αυτήν την τροφή;",
    fr: "Votre enfant a-t-il été diagnostiqué par un médecin comme ayant une allergie à cet aliment?",
    de: "",
    ka: "ექიმის მიერ დაუდგინდა თუ არა კვებითი ალერგია თქვენს შვილს ამ საკვების მიმართ?",
    fi: "Onko lääkäri koskaan diagnosoinut lapsellesi allergiaa tälle ruoalle?",
  },
  isRequired: isRequired,
  choices: [yes, no],
};
const s5q5 = {
  type: "radiogroup",
  name: "q4s5q5",
  title: {
    default: "Is your child now able to eat this food without symptoms?",
    gr: "Το παιδί σας μπορεί να φάει αυτή την τροφή τώρα χωρίς συμπτώματα;",
    fr: "Votre enfant est-il maintenant capable de manger cet aliment sans symptômes ?",
    de: "",
    ka: "ამჟამად იღებს თუ არა თქვენი შვილი ამ საკვებს ალერგიული სიმპტომების გამოვლენის გარეშე? ",
    fi: "Voiko lapsesi nyt syödä tätä ruokaa ilman oireita?",
  },
  isRequired: isRequired,
  choices: [yes, no],
};

export const elementsS5 = [s5q1, s5q2, s5q3, s5q4, s5q5];
